import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  MenuItem,
  IconButton,
  Grid,
  Typography,
  InputAdornment
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Selector from "../../../components/Selector";

const initialForm = {
  name: "",
  rnc: "",
  address: "",
  contact: "",
  phone: "",
  email: "",
  status: "Active",
};

export default function CrearBancoDialog({ open, onClose }) {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const validate = () => {
    let newErrors = {};
    if (!form.name) newErrors.name = "Nombre es requerido";
    if (!form.type) newErrors.type = "Tipo de cuenta es requerido";
    if (!form.opening_date) newErrors.opening_date = "Fecha de apertura es requerida";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }   

    
    const url = `${process.env.REACT_APP_SERVER_URL}/api/bancos`;
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          nombre:form.name,
          tipo_cuenta:form.type,
          numero_cuenta:form.account_number,
          valor_inicial:form.initial_balance,
          fecha_apertura:form.opening_date,
          idcompany:localStorage.getItem('idcompany'),
          creado_por:localStorage.getItem('id')
        })
      });

      const text = await response.text();
      try {
        const data = JSON.parse(text);
        if (!response.ok) {
          throw new Error(data.error || 'Error al crear banco');
        }
        onClose()
      } catch (e) {
        throw new Error('Respuesta no es JSON: ' + text);
      }
    } catch (error) {
      setErrors(prev => ({...prev, general: error.message || 'Error desconocido'}));
      throw error;
    }


  };

  

  const handleClose = () => {
    setForm(initialForm);
    setErrors({});
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Agregar Cuenta Bancaria
        <Typography variant="body1" color="text.secondary" textAlign={"left"} sx={{mt:1}}>Agregar una cuenta bancaria a la empresa</Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ mt: 1 }}>
            <Grid container spacing={2}>
                <Grid item size={6}>
                    <TextField placeholder='Nombre' name='name' value={form.name} onChange={handleChange} error={!!errors.name} helperText={errors.name} fullWidth/>
                </Grid>
                <Grid item size={6}>
                    <Selector placeholder='Tipo de Cuenta' name='type' options={[{label:"Banco Nacional", value:"banco_nacional"},{label:"Tarjeta de Credito", value:"tarjeta_credito"},{label:"Efectivo", value:"efectivo"}]} value={form.type} onChange={handleChange} error={!!errors.type} helperText={errors.type} fullWidth/>
                </Grid>
                <Grid item size={12}>
                    <TextField placeholder='Numero de Cuenta' name='account_number' value={form.account_number} onChange={handleChange} error={!!errors.account_number} helperText={errors.account_number} fullWidth/>
                </Grid>
                <Grid item size={6}>
                    <TextField InputProps={{startAdornment: <InputAdornment position="start">RD$</InputAdornment>,endAdornment: <InputAdornment position="end">DOP</InputAdornment>}} type='number' placeholder='Saldo Inicial' name='initial_balance' value={form.initial_balance} onChange={handleChange} error={!!errors.initial_balance} helperText={errors.initial_balance} fullWidth/>
                </Grid>
                <Grid item size={6}>
                    <TextField type='date' helperText='Fecha de Apertura' placeholder='Fecha de Apertura' name='opening_date' value={form.opening_date} onChange={handleChange} error={!!errors.opening_date} fullWidth/>
                </Grid>
            </Grid>

        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} color="inherit">
          Cancelar
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primarybutton" sx={{fontWeight:"bold"}}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
